<template>
    <div class="container">
        <h2>Log de Erros</h2>
        <div class="caixa">
            <div v-for="(mensagen, idx) in mensagens" :key="idx">
                {{ mensagen }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LogVerificação",
    props: {
        mensagens: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped>
.container {
    background-color: transparent;
    /* margin: 0 -12px 0 -12px; */
    padding: 0;
}

.caixa {
    background-color: rgb(196, 204, 204);
    border: 1px solid gray;
    padding: 10px;
    width: 100%;
    height: 200px;
    overflow-y: scroll;
}
</style>
